import { Link } from '@sorare/routing';
import type { GameplayTier } from '@sorare/core/src/__generated__/globalTypes';
import { GameplayTierStars } from '@sorare/core/src/components/card/GameplayTierStars';

import { useCraftingPoolTierPath } from '#src/hooks/useCraftingPoolPath.ts';

type Props = {
  gameplayTier: GameplayTier;
};

export const PlayerGameplayTier = ({ gameplayTier }: Props) => {
  const craftingPoolTierPath = useCraftingPoolTierPath();
  const to = craftingPoolTierPath(gameplayTier);

  const stars = <GameplayTierStars gameplayTier={gameplayTier} />;

  if (!to) {
    return stars;
  }

  return <Link to={to}>{stars}</Link>;
};
